module.exports = __webpack_public_path__ + "img/vgs.3b8d2c8b.png";